import React, { useState } from "react";
import { toast } from "sonner";
export const PRODUCT_TAGS = ["CNC", "FGTS", "Consignado", "CLT", "Antecipação", "Outros bancos", "Seguro", "Super Conta"];
export const tagsOf = contact => Array.isArray(contact?.product_tags) ? contact.product_tags.filter(tag => PRODUCT_TAGS.includes(tag)) : [];

export default function ContactProductTags({ contact, onSave }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState([]);
  const [saving, setSaving] = useState(false);
  const saved = tagsOf(contact);
  const save = async () => {
    if (saving) return;
    setSaving(true);
    try { await onSave(contact.phone, draft); setOpen(false); toast.success("Produtos salvos"); }
    catch (error) { toast.error(error.response?.data?.detail || "Não foi possível salvar os produtos"); }
    finally { setSaving(false); }
  };
  return <div className="px-4 py-2 border-b border-slate-800 flex-none text-xs">
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-slate-400">Produtos</span>
      {saved.length ? saved.map(tag => <span key={tag} className="rounded bg-pink-500/15 px-2 py-1 text-pink-200">{tag}</span>) : <span className="text-slate-500">Nenhum selecionado</span>}
      <button type="button" className="text-pink-300 underline" onClick={() => { if (!open) { setDraft(saved); setOpen(true); } else if (!saving) setOpen(false); }}>Editar produtos</button>
    </div>
    {open && <div className="mt-2 rounded border border-slate-700 p-2">
      <p className="mb-2 text-slate-400">Selecione os produtos de interesse do cliente.</p>
      <div className="flex flex-wrap gap-2">{PRODUCT_TAGS.map(tag => <label key={tag} className="flex items-center gap-1 rounded bg-slate-900 px-2 py-1">
        <input type="checkbox" checked={draft.includes(tag)} disabled={saving} onChange={e => setDraft(current => e.target.checked ? [...current, tag] : current.filter(value => value !== tag))} />{tag}
      </label>)}</div>
      <div className="mt-2 flex gap-2">
        <button type="button" disabled={saving} onClick={save} className="rounded bg-pink-600 px-3 py-2 disabled:opacity-50">{saving ? "Salvando..." : "Salvar produtos"}</button>
        <button type="button" disabled={saving} onClick={() => setOpen(false)} className="rounded border border-slate-700 px-3 py-2">Cancelar</button>
      </div>
    </div>}
  </div>;
}
